import {
  ChangeDetectionStrategy,
  Component,
  inject,
  OnInit,
} from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { environmentProvider } from '@shared/environment-provider';
import { subscribeOnce } from '@tmx/core';

@Component({
  selector: 'reset-redirect',
  template: '',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
})
export class ResetRedirectComponent implements OnInit {
  private readonly route = inject(ActivatedRoute);
  private readonly router = inject(Router);

  ngOnInit() {
    subscribeOnce(
      this.route.queryParams,
      (params: { email?: string; token?: string }) => {
        const hasEmailParam = typeof params.email === 'string';
        const hasTokenParam = typeof params.token === 'string';
        const onboardingSiteUrl =
          environmentProvider.getEnvironment().onboardingSiteUrl;
        window.location.href =
          hasEmailParam && hasTokenParam
            ? `${onboardingSiteUrl}/auth${this.router.url}`
            : onboardingSiteUrl;
      }
    );
  }
}
